import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

export default function AdherentForm(props) {

    const [email, setEmail] = useState('')



    const [textReturn, setTextReturn] = useState('')

    var addCredit = function () {
        setTextReturn('En cours ...')
        fetch("https://playattitude.fr/admin/user/adherent", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify({ email})
        })
            .then(res => res.json())
            .then(res => {
                if (res.response)
                    setTextReturn(res.response)
            })
    }


    return (
        <div className="center trainingForm">
            <h2>Ajouter un adhérent</h2>
            <form noValidate autoComplete="off">
                <div >
                    <TextField type="text" id="standard-basic" label="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
                </div><br />
                <div>
                    <Button variant="contained" onClick={() => addCredit()}>Valider</Button>
                </div>
            </form>
            <div><p>{textReturn}</p></div>
        </div>
    );
}